import React, { Component } from 'react';
import {BASE_PATH, STATUS_NAME} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";

class Item extends Component {
  constructor(props) {
    super(props);
  }

  tolinkDetail = (event) => {
    const t = window.location.href.split("?")[1].replace(/[\?&]record_id=[^&]+/, '')
    return BASE_PATH + "wp-admin/admin.php?" + t + "&record_id=" + this.props.record.resource_id;
  }

  copy = (e) => {
    const textarea = document.createElement("textarea");
    // textarea.value = this.props.record.resource_id;
    textarea.value = e;
    textarea.style.top = 0;
    textarea.style.left = 0;
    textarea.style.position = "fixed";

    // 흐름 3.
    document.body.appendChild(textarea);
    // focus() -> 사파리 브라우저 서포팅
    textarea.focus();
    // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
    textarea.select();
    // 흐름 4.
    document.execCommand("copy");
    // 흐름 5.
    document.body.removeChild(textarea);
    // alert("클립보드에 복사되었습니다.");
  }

  render() {
    const record = this.props.record;
    // console.log(this.props)

    let rdb = {
      'scie': {'name': 'SE', 'class': 'btn db-check'},
      'ssci': {'name': 'SS', 'class': 'btn db-check'},
      'ahci': {'name': 'AH', 'class': 'btn db-check'},
      'esci': {'name': 'ES', 'class': 'btn db-check'},
      'scopus': {'name': 'SP', 'class': 'btn db-check'},
      'nature' : { 'name' : 'NA' , 'class' : 'btn db-check'},
      'kci': {'name': 'KC', 'class': 'btn db-check'},
      'kci_great': {'name': 'KG', 'class': 'btn db-check'},
      'kci_can': {'name': 'KD', 'class': 'btn db-check'}
    }

    record.registered_db && record.registered_db.map((db, index) => {
      if (db === 'SCIE') rdb.scie.class += ' checked';
      else if (db === 'SSCI') rdb.ssci.class += ' checked';
      else if (db === 'AHCI') rdb.ahci.class += ' checked';
      else if (db === 'ESCI') rdb.esci.class += ' checked';
      else if (db === 'Scopus') rdb.scopus.class += ' checked';
      else if(db.name === 'Nature Index') rdb.nature.class += ' checked';
      else if (db === 'KCI') rdb.kci.class += ' checked';
      else if (db === 'KCI우수') rdb.kci_great.class += ' checked';
      else if (db === 'KCI후보') rdb.kci_can.class += ' checked';
    })

    if(record.kri_wos !== '') rdb.scie.class += ' kri-verified';
    if(record.kri_scopus !== '') rdb.scopus.class += ' kri-verified';
    if(record.kri_kci !== '') rdb.kci.class += ' kri-verified';

    return (
      <tr>
        <td>{this.props.no}</td>
        <td>
          <NavLink to={this.tolinkDetail}>{record.resource_title.substr(0, 30)}</NavLink>
          <div className="pl-0 pr-0 ml-0 mr-0">
            {Object.keys(rdb).map((db, index) => {
              return (<span key={index} className={rdb[db].class}>{rdb[db].name}</span>)
            })}
          </div>
        </td>
        <td>
          <div className="m-0 p-0">
            <span className="btn cp-btn" onClick={() => this.copy(record.resource_title)}>CT</span><span className="btn cp-btn" onClick={() => this.copy(record.resource_id)}>CN</span>
          </div>
          {!record.resource_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
            : record.resource_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.resource_status]}</span>
              : record.resource_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.resource_status]}</span>
                : record.resource_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.resource_status]}</span>
                  : record.resource_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.resource_status]}</span>
                    : ''
          }
        </td>
      </tr>
    )
  }
}

export default Item;